import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=9b434b66&scoped=true&"
import script from "./Beneficiaries.vue?vue&type=script&lang=js&"
export * from "./Beneficiaries.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=9b434b66&scoped=true&lang=css&"
import style1 from "./Beneficiaries.vue?vue&type=style&index=1&id=9b434b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b434b66",
  null
  
)

export default component.exports